import { CSSProperties } from "react";

export interface OnboardingQuestThemeData {
    accentColor: string | undefined;
    theme?: string;
    borderRadius?: string;
    buttonColor?: string;
    images?: string[];
}

export interface OnboardingBrandTheme {
    accentColor?: string;
    background?: string;
    borderRadius?: string;
    primaryButton?: string;
    secondaryButton?: string;
    contentColor?: string;
    fontFamily?: string;
    logo?: string;
    primaryColor?: string;
    secondaryColor?: string;
    tertiaryColor?: string;
    titleColor?: string;
}

export type PartialBrandTheme = Partial<OnboardingBrandTheme>;

export type PartialQuestThemeData = Partial<OnboardingQuestThemeData>;


export interface OnboardingStyleConfig {
    Form?: CSSProperties;
    Topbar?: CSSProperties;
    Heading?: CSSProperties;
    Description?: CSSProperties;
    Input?: CSSProperties;
    EmailError?: {
        text?: string;
        errorStyle?: CSSProperties;
    };
    TextError?: {
        text?: string;
        errorStyle?: CSSProperties;
    };
    NumberError?: {
        text?: string;
        errorStyle?: CSSProperties;
    };
    TextAreaError?: {
        text?: string;
        errorStyle?: CSSProperties;
    };
    Label?: CSSProperties;
    TextArea?: CSSProperties;
    PrimaryButton?: CSSProperties;
    SecondaryButton?: CSSProperties;
    SingleChoice?: {
        style?: CSSProperties;
        selectedStyle?: CSSProperties;
        hoverBackground?: string
    };
    MultiChoice?: {
        style?: CSSProperties;
        selectedStyle?: CSSProperties;
        isLabel?: boolean;
    };
    ProgressBar?: {
        completeTabColor?: string;
        currentTabColor?: string;
        pendingTabColor?: string;
    };

    Footer?: {
        FooterStyle?: CSSProperties;
        FooterTextStyle?: CSSProperties;
        FooterIcon?: CSSProperties;
        FooterText?: string;
        FooterLink?: string;
    };
};


export interface OnboardingThemeConfig {
    backgroundColor?: string;
    primaryColor?: string;
    secondaryColor?: string;
    fontFamily?: string;
    buttonColor?:string;
}

export const DEFAULT_QUEST_THEME: PartialQuestThemeData = {
    accentColor: "",
    theme: "",
    borderRadius: "",
    buttonColor: "",
    images: []
};

export const DEFAULT_BRAND_THEME: PartialBrandTheme = {
    accentColor: "",
    background: "",
    borderRadius: "",
    primaryButton: "",
    contentColor: "",
    fontFamily: "",
    logo: "",
    primaryColor: "",
    secondaryColor: "",
    tertiaryColor: "",
    titleColor: ""
};